import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { TAction } from '../actions/types/action';
import { TRaidRankingsClientState } from '../libs/store';

export default function siteMeta(state: any = {}, action: TAction<any>): Partial<TRaidRankingsClientState> {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return state; // keep the initial state that was loaded
    }
    default:
      return state;
  }
}
